import type { Invoice } from "@freightsimple/generated-dashboard-openapi-client/models/Invoice";
import { InvoiceState } from "@freightsimple/generated-dashboard-openapi-client/models/InvoiceState";
import { InvoiceType } from "@freightsimple/generated-dashboard-openapi-client/models/InvoiceType";
import type { PaymentMethodsState } from "../Types/paymentsPaymentTypes";

export function shouldBePaid(invoice: Invoice): boolean {
  return (
    invoice.invoiceState === InvoiceState.Unpaid &&
    (invoice.invoiceType === InvoiceType.AdditionalCharge ||
      invoice.invoiceType === InvoiceType.ShipmentCharge)
  );
}

export function isBankAccount(
  state: PaymentMethodsState,
  selectedPaymentMethod: string | undefined,
) {
  return (
    state.bankAccounts.find(
      (ba) => ba.stripePaymentMethodId === selectedPaymentMethod,
    ) !== undefined
  );
}

export function isCreditCard(
  state: PaymentMethodsState,
  selectedPaymentMethod: string | undefined,
) {
  return (
    state.creditCards.find(
      (cc) => cc.stripePaymentMethodId === selectedPaymentMethod,
    ) !== undefined
  );
}
